import { compose, inRange, get } from 'lodash/fp'
import { QUIZZES } from './quizzes'

const ROOMS = [
  'living-room',
  'kitchen',
  'bathroom',
  'laundry-room',
  'garage',
  'bedroom',
  'city',
]

// Returns a FormData object containing key-value data from the provided
// object.
export const createFormData = (data) => {
  const formData = new FormData()

  for (const key of Object.keys(data)) {
    formData.append(key, data[key])
  }

  return formData
}

// Posts a form to Netlify with the provided form name and values. Returns true
// if successful, false otherwise.
export const postNetlifyForm = async (formName, values) => {
  try {
    const response = await fetch('/', {
      method: 'post',
      body: createFormData({ 'form-name': formName, ...values }),
    })

    return compose(inRange(200, 300), get('status'))(response)
  } catch (error) {
    console.error(error)
    return false
  }
}

export const isLastRoom = (roomsCleared, roomId) => {
  return (
    roomsCleared.length === ROOMS.length - 1 && !roomsCleared.includes(roomId)
  )
}

export const getRoomButtonText = () => {
  return 'Continue'
}

export const selectRandomRoom = (
  roomsCleared,
  setSelectedRoom,
  setStartButtonUrl,
) => {
  const newRoom = ROOMS.find((room) => !roomsCleared.includes(room))

  setSelectedRoom(newRoom)
  setStartButtonUrl('/' + newRoom)
}

/**
 * For the provided roomId, return the question and answer for the pop quiz
 * shown after the room is cleared for the first time.
 */
export const getRoomQuizQA = (roomId) => {
  const roomQuizzes = QUIZZES[roomId]
  const randomIndex = Math.floor(Math.random() * roomQuizzes.length)

  return roomQuizzes[randomIndex]
}

export const delay = (time) =>
  new Promise((resolve) => setTimeout(resolve, time))

export const getQuizSubmitButtonText = ({ roomsCleared, roomId }) => {
  return isLastRoom(roomsCleared, roomId) ? 'All Pau!' : 'More Rooms'
}



// WEBPACK FOOTER //
// ./src/helpers.js